<template>
  <div class="content-funding col-12">
    <!-- chart here -->
    <div class="content-funding__chart">
    
      <!-- chart header -->
      <div v-if="content.chart" class="row" style="padding-top: 0">
        <div class="col-xs-12 col-sm-10 col-sm-offset-1 offset-sm-1 col-md-8 col-md-offset-2 offset-md-2">
          <h3>{{ content.chart.title }}</h3>

          <p>
            {{ content.chart.instruction }}
          </p>
        </div>
      </div>

      <!-- chart controls and viz -->
      <FundingDealsViz />

      <!-- footer -->
      <div class="funding-chart__footer text-center">
        *Deals with undisclosed amounts (shown as empty circles with outlines) are not included in the funding count.
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Fundings',
  components: {
    FundingDealsViz: () => import('@/components/content/charts/FundingDealsViz.vue'),
  },
  props: {
    content: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.content-funding {
  .content-funding__intro {
    padding: 60px 0;

    .funding-intro__prelude {
      p:last-child {
        margin-bottom: 0;
      }
    }
  }

  .content-funding__chart {
    padding: 60px 0;

    h3 {
      font-size: 22px;
      line-height: 1.45;
      font-weight: 700;
    }
  }

  @media #{map-get($media-breakpoints, 'mobile')} {
    .content-funding__intro {
      padding: 30px 0;
    }

    .content-funding__chart {
      padding: 30px 0;
    }
  }
}
</style>
